export function formatViewers(value: number): string {
  if (value >= 10000) {
    const w = value / 10000;
    return `${w >= 100 ? Math.round(w) : w.toFixed(1)}万`;
  }
  return String(value);
}

export function formatDuration(minutes: number): string {
  if (minutes <= 0) return "未开播";
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h <= 0) return `${m} 分钟`;
  if (m === 0) return `${h} 小时`;
  return `${h} 小时 ${m} 分`;
}

export function formatFollowers(value: number): string {
  if (value >= 10000) return `${(value / 10000).toFixed(1)}万`;
  return String(value);
}